import React from "react";
import { Routes, Route } from "react-router-dom";

import List from "./list";
import View from "./view";

export function Campaign() {
  return (
    <Routes>
      <Route path=":id" element={<View />} />
      <Route index element={<List />} />
    </Routes>
  );
}

export { Campaign as default };
